import { useHealthCheck } from '../../../hooks/useHealthCheck';

export function ReleaseNameBadge() {
  const { health } = useHealthCheck();

  if (!health?.releaseName) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 text-xs text-gray-500 pointer-events-none select-none">
      <span className="opacity-60">{health.releaseName}</span>
    </div>
  );
}
